import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  type ButtonProps,
} from "@mui/material";
import { type FC, type ReactNode } from "react";
import { useDialog } from "../../../../../../utils/hooks/use-dialog";
import type { ChannelName } from "../../../../../channels/types";
import { prettyChannelName } from "../../../../../channels/utils";

type Props = {
  channelName: ChannelName;
  buttonText: string;
  children: ReactNode;
} & ButtonProps;

export const PreviewMissingButton: FC<Props> = ({
  buttonText,
  channelName,
  children,
  ...buttonProps
}) => {
  const dialog = useDialog();

  return (
    <>
      <Button
        color="info"
        size="small"
        variant="text"
        onClick={() => dialog.handleOpen("missing")}
        data-analytics-id="people-missing-channel-button"
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        <DialogTitle>People missing {prettyChannelName(channelName)}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={dialog.handleClose} data-analytics-id="people-in-segment-close-button">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
